import axiosConfig from "./axiosConfig";

export interface BulkTagsRequest {
  leadIds: string[];
  addTags?: string[];
  removeTags?: string[];
}

export interface BulkTagsResponse {
  updated: number;
  addTags: string[];
  removeTags: string[];
}

const postLeadBulkTags = async (
  authToken: string,
  body: BulkTagsRequest
): Promise<BulkTagsResponse> => {
  const { data } = await axiosConfig.post(`/leads/bulk-tags`, body, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default postLeadBulkTags;
